var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 11.75,
    fill: "#E8F3FF",
    stroke: "#122D62",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 12.6875C19.375 12.7704 19.3421 12.8499 19.2835 12.9085C19.2249 12.9671 19.1454 13 19.0625 13H12.5V19.5625C12.5 19.6454 12.4671 19.7249 12.4085 19.7835C12.3499 19.8421 12.2704 19.875 12.1875 19.875C12.1046 19.875 12.0251 19.8421 11.9665 19.7835C11.9079 19.7249 11.875 19.6454 11.875 19.5625V13H5.3125C5.22962 13 5.15013 12.9671 5.09153 12.9085C5.03292 12.8499 5 12.7704 5 12.6875C5 12.6046 5.03292 12.5251 5.09153 12.4665C5.15013 12.4079 5.22962 12.375 5.3125 12.375H11.875V5.8125C11.875 5.72962 11.9079 5.65013 11.9665 5.59153C12.0251 5.53292 12.1046 5.5 12.1875 5.5C12.2704 5.5 12.3499 5.53292 12.4085 5.59153C12.4671 5.65013 12.5 5.72962 12.5 5.8125V12.375H19.0625C19.1454 12.375 19.2249 12.4079 19.2835 12.4665C19.3421 12.5251 19.375 12.6046 19.375 12.6875Z",
    fill: "#122D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.81cbdf7dcd39cf01ca67946a14b54496.svg";
export { ForwardRef as ReactComponent };